import { t } from 'i18next';
import { getTimeDateString } from '../../../utility/date';

/** Single date range for LMS / leads page when `listingsUnified` — Surge expects `start_date` & `end_date`. */
export function getUnifiedTruLeadsStaffDateRangeFilterItem() {
  return {
    label: t('Leads'),
    key: 'leads',
    queryParamKey: ['start_date', 'end_date'],
    placeholder: t('Select Date Range'),
    type: 'dateRange',
    getOptionLabel: (value) =>
      value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - '),
  };
}

export const LMS_TO_UNIFIED_TRU_LEADS_KEYS = Object.freeze({
  'q[interests_listing_id_eq]': 'q[listing_id]',
  'q[name_start]': 'q[buyer_name]',
  'q[created_at_gteq]': 'q[oldest_lead_start_date]',
  'q[created_at_lteq]': 'q[oldest_lead_end_date]',
  'q[updated_at_gteq]': 'q[latest_lead_start_date]',
  'q[updated_at_lteq]': 'q[latest_lead_end_date]',
  'q[user_id_eq]': 'q[user_id]',
});

function decodeSegmentKey(rawKey) {
  if (!rawKey) return '';
  try {
    return decodeURIComponent(rawKey.replace(/\+/g, ' '));
  } catch {
    return rawKey;
  }
}

/**
 * @param {string} queryString - `key=value&...` from `mapQueryParams` (LMS naming)
 * @returns {string} same pairs with TruLeads unified q[] keys where applicable
 */
export function remapLmsLeadQueryStringForUnifiedTruLeads(queryString) {
  if (!queryString || typeof queryString !== 'string') {
    return typeof queryString === 'string' ? queryString : '';
  }
  return queryString
    .split('&')
    .map((segment) => {
      if (!segment) return '';
      const eq = segment.indexOf('=');
      const rawKey = eq === -1 ? segment : segment.slice(0, eq);
      const rawVal = eq === -1 ? '' : segment.slice(eq + 1);
      const lookup = decodeSegmentKey(rawKey);
      const mapped = LMS_TO_UNIFIED_TRU_LEADS_KEYS[lookup];
      const outKey = mapped != null ? mapped : rawKey;
      return rawVal !== '' ? `${outKey}=${rawVal}` : outKey;
    })
    .filter(Boolean)
    .join('&');
}
